import * as FIELD_NAME from 'constant/form-item-names'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import FORM_LAYOUT from 'constant/form-layout'
import OrganisationSelect from 'view/component/form-items/user-org-select'
import SitesUserTypeSelect from 'view/component/form-items/sites-user-type-select'
import EmailInput from 'view/component/form-items/email-input'
import FirstNameInput from 'view/component/form-items/first-name-input'
import SecondNameInput from 'view/component/form-items/second-name-input'
import PasswordInput from 'view/component/form-items/password-input'

const GENERAL = 'general'

const UserForm = ({ form, passwordRequired, user, userTypes, readOnly }) => {
  useEffect(() => {
    const userType = userTypes?.find(({ name }) => name === GENERAL)
    const defaultUser = {
      [FIELD_NAME.USER_TYPE_UUID]: userType?.uuid
    }
    form.setFieldsValue(user || defaultUser)
  }, [userTypes])

  return (
    <Form
      form={form}
      layout={FORM_LAYOUT}
    >
      <FirstNameInput disabled={readOnly} />
      <SecondNameInput disabled={readOnly} />
      <EmailInput disabled={readOnly} />
      <PasswordInput
        disabled={readOnly}
        required={passwordRequired}
      />
      <SitesUserTypeSelect disabled={readOnly} />
      <OrganisationSelect disabled={readOnly} />
    </Form>
  )
}

UserForm.propTypes = {
  form: PropTypes.object,
  passwordRequired: PropTypes.bool,
  readOnly: PropTypes.bool,
  user: PropTypes.object,
  userTypes: PropTypes.array
}

const mapStateToProps = (state) => ({
  userTypes: state.user.userTypes
})

export default connect(mapStateToProps)(UserForm)
